import React from 'react';

const industries = [
  { name: 'Construction', icon: '/pictures/construction_862007cce5.svg' },
  { name: 'Investment', icon: '/pictures/investment_c2fdb15f07.svg' },
  { name: 'Healthcare', icon: '/pictures/healthcare_38b01538b4.svg' },
  { name: 'Travel & Hospitality', icon: '/pictures/travel_and_hospitality_556eea5e04.svg' },
  { name: 'Insurance', icon: '/pictures/insurance_b82ff81ee7.svg' },
  { name: 'Telecoms', icon: '/pictures/telecommunication_106f71dfd2.svg' },
  { name: 'Marketing & Advertising', icon: '/pictures/marketing_and_advertising_eb93c5da1c.svg' },
  { name: 'Professional service', icon: '/pictures/professional_service_abb9465505.svg' },
  { name: 'Retail & E-commerce', icon: '/pictures/retail_and_e_commerce_041c71b465.svg' },
];

export default function Industries() {
  return (
    <section style={{ padding: '100px 24px', background: 'white' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Section label */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
          <div style={{ width: '24px', height: '3px', backgroundColor: '#0099CC', borderRadius: '2px' }}></div>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#0099CC', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Our Expertise
          </span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'start' }}>
          {/* Left */}
          <div>
            <h2 style={{ fontSize: 'clamp(28px, 3vw, 42px)', fontWeight: '700', color: '#111827', lineHeight: 1.2, marginBottom: '20px', letterSpacing: '-0.5px' }}>
              We specialize in software development.
            </h2>
            <h3 style={{ fontSize: '22px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>
              We believe in great ideas
            </h3>
            <p style={{ fontSize: '16px', color: '#6B7280', lineHeight: 1.75, margin: 0 }}>
              We are a software development company developing flagship products that deliver exceptional growth and carefully select highly skilled teams that are perfectly matched to achieve your unique goals. We master both technology and security logic. This means that we are experts not only in assessing your needs and developing the perfect software solution but also in maintaining and improving it for you.
            </p>
            <br />
            <p style={{ fontSize: '16px', color: '#6B7280', lineHeight: 1.75, margin: 0 }}>
              We are committed to creating a positive and engaging work environment that fosters personal and professional growth and helps our team members thrive.
            </p>
          </div>

          {/* Right - Industries grid */}
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px' }}>
              {industries.map((industry) => (
                <div
                  key={industry.name}
                  className="industry-item"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                    cursor: 'pointer',
                  }}
                >
                  <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '16px',
                    background: '#F0F9FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '14px',
                  }}>
                    <img src={industry.icon} alt={industry.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: '500', color: '#374151', textAlign: 'center', lineHeight: 1.3 }}>
                    {industry.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .industries-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
